/**
 * The URI prefix for URIs.
 */
export const URI_PREFIX = 'spotify:';
/**
 * The URL prefix for Play.
 */
export const PLAY_HTTP_PREFIX = 'http://play.spotify.com/';
/**
 * The HTTPS URL prefix for Play.
 */
export const PLAY_HTTPS_PREFIX = 'https://play.spotify.com/';
/**
 * The URL prefix for Open.
 */
export const OPEN_HTTP_PREFIX = 'http://open.spotify.com/';
/**
 * The HTTPS URL prefix for Open.
 */
export const OPEN_HTTPS_PREFIX = 'https://open.spotify.com/';
/**
 * The path prefix for paths without domain prefix.
 */
export const PATH_PREFIX = '/';
//# sourceMappingURL=prefix.js.map